import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { DatePipe } from "@angular/common";

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

import { UserService } from "../../../shared/services/user.service";

import { DataService_scanstationtracking } from "./shared/data.service";

import { wsScanStationTrackingInfo } from "./shared/wsScanStationTrackingInfo";
import { wsScanStationTrackingUpdateParmInfo } from "./shared/wsScanStationTrackingUpdateParmInfo";
import { wsScanStationTrackingUpdateItemInfo } from "./shared/wsScanStationTrackingUpdateParmInfo";

import { ViewChild } from "@angular/core";

import * as moment from "moment";

@Component({
	selector: "app-root",
	templateUrl: "./scanstationtracking.component.html",
	styleUrls: ["./scanstationtracking.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class ScanStationTrackingComponent implements OnInit, OnDestroy {
	@ViewChild("mydt") mydt: Table;
	@ViewChild("filterFacilityName", { static: false })
	public filterFacilityName: Dropdown;
	@ViewChild("filterSchoolName", { static: false })
	public filterSchoolName: Dropdown;

	constructor(
		private datepipe: DatePipe,
		private dataService: DataService_scanstationtracking,
		private userService: UserService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public TotalDeCommissionCount: number = 0;

	//	Station List
	public lstStation: wsScanStationTrackingInfo[] = [];
	public lstStationChecked: wsScanStationTrackingInfo[] = [];

	//	Filters
	public lstFacilitys: any = [];
	public lstSchools: any = [];
	public lstisDecommissionedDesc: any = [];

	public pagefirst: number = 0;
	public pagerows: number = 25;

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.isBusy = true;
		this.dataService.ScanStationTrackingSelectList().subscribe((data) => this.ScanStationTrackingSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		this.isBusy = true;
		this.dataService.ScanStationTrackingSelectList().subscribe((data) => this.ScanStationTrackingSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ScanStationTrackingSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ScanStationTrackingSelectList_Complete(data: any) {
		this.lstStationChecked = [];
		this.TotalDeCommissionCount = 0;

		this.lstStation = data;

		this.lstStation.forEach((item) => {
			if (item.isDecommissioned == true) {
				this.TotalDeCommissionCount += 1;
				this.lstStationChecked.push(item);
			}

			item.LastSyncDate = new Date(item.LastSyncDate);
		});

		//
		//	Set Filter Lists
		//
		this.lstFacilitys = Array.from(new Set(this.lstStation.map((item: any) => item.FacilityName))).sort();
		this.lstSchools = Array.from(new Set(this.lstStation.map((item: any) => item.SchoolName))).sort();
		this.lstisDecommissionedDesc = Array.from(new Set(this.lstStation.map((item: any) => item.isDecommissionedDesc))).sort();

		//
		//	Reset Filters
		//
		this.onClearFilters();

		//
		//	Reset Sort
		//
		this.mydt.multiSortMeta = [];
		this.mydt.multiSortMeta.push({ field: "FacilityName", order: 1 });
		this.mydt.multiSortMeta.push({ field: "ScanStation", order: 1 });
		this.mydt.sortMultiple();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClearFilters
	//
	//-----------------------------------------------------------------------------------------------------
	onClearFilters() {
		this.filterFacilityName.clear(null);
		this.filterSchoolName.clear(null);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdate() {
		let DeCommissionCount: number = 0;
		let ReCommissionCount: number = 0;

		let parms: wsScanStationTrackingUpdateParmInfo = {
			c_PersonID: this.user.personID,
			ChangedItems: [],
		};

		//
		//	Check For A Change From True to False
		//
		this.lstStation.forEach((item1) => {
			if (item1.isDecommissioned == true) {
				let isFound: boolean = false;

				this.lstStationChecked.forEach((item2) => {
					if (item2.ScanStationID == item1.ScanStationID) {
						isFound = true;
					}
				});

				if (isFound == false) {
					let chgitem: wsScanStationTrackingUpdateItemInfo = {
						ScanStationID: item1.ScanStationID,
						isDecommissioned: false,
					};

					ReCommissionCount += 1;
					parms.ChangedItems.push(chgitem);
				}
			}
		});

		//
		//	Check For A Change From False to True
		//
		this.lstStationChecked.forEach((item1) => {
			if (item1.isDecommissioned == false) {
				let chgitem: wsScanStationTrackingUpdateItemInfo = {
					ScanStationID: item1.ScanStationID,
					isDecommissioned: true,
				};

				DeCommissionCount += 1;
				parms.ChangedItems.push(chgitem);
			}
		});

		//
		//	Final Processing
		//
		if (DeCommissionCount == 0 && ReCommissionCount == 0) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "You have not made any changes.",
				header: "Update ScanStation Tracking",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
			return;
		} else {
			var message: string = "";
			message =
				"Number of ScanStations to be decommissioned: " +
				DeCommissionCount.toString() +
				"<br>" +
				"Number of ScanStations to be recommissioned: " +
				ReCommissionCount.toString() +
				"<br>" +
				"<br>" +
				"Are you sure you you want to perform this action?";

			this.confirmationService.confirm({
				acceptLabel: "Yes",
				rejectVisible: true,
				message: message,
				header: "Update ScanStation Tracking",
				icon: "fa fa-info",
				accept: () => {
					this.ProcessUpdate(parms);
				},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ProcessUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	ProcessUpdate(parms: wsScanStationTrackingUpdateParmInfo) {
		this.isBusy = true;
		this.dataService.ScanStationTrackingUpdate(parms).subscribe((data) => this.ScanStationTrackingUpdate_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ScanStationTrackingUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ScanStationTrackingUpdate_Complete(e: any) {
		this.isBusy = false;

		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onExport
	//
	//-----------------------------------------------------------------------------------------------------
	onExport() {
		//
		// Get list of values to export
		//
		var lstData: any = [];

		if (this.mydt.filteredValue != null) {
			lstData = this.mydt.filteredValue;
		} else {
			lstData = this.mydt._value;
		}

		//
		// Create CSV
		//
		var data: string = "";

		//
		// Create csv based on Table's data
		//

		data += "ScanStation,";
		data += "Facility,";
		data += "School,";
		data += "Decommissioned?,";
		data += "Decommission Date,";
		data += "Last Sync Date,";
		data += "\n";

		//
		// Go through each entry in the table and add the data
		//
		for (var i = 0; i < lstData.length; i++) {
			var next = lstData[i];

			var fdDate: string = "";
			if (next.DecommissionedDate != "" && next.DecommissionedDate != "0001-01-01T00:00:00") {
				fdDate = moment(new Date(next.DecommissionedDate)).format("MM/DD/YYYY h:mm a");
			}

			var fsDate: string = "";
			if (next.HasSyncDate == true) {
				fsDate = moment(new Date(next.LastSyncDate)).format("MM/DD/YYYY h:mm a");
			}

			data += '"' + next.ScanStation + '",';
			data += '"' + next.FacilityName + '",';
			data += '"' + next.SchoolName + '",';
			data += '"' + next.isDecommissionedDesc + '",';
			data += '"' + fdDate + '",';
			data += '"' + fsDate + '",';
			data += "\n";
		}

		//
		// Download CSV
		//

		var blob = new Blob([data], { type: "text" });
		var url = window.URL.createObjectURL(blob);

		var a = document.createElement("a");
		a.href = url;

		a.download = "ScanStationTracking_" + moment(new Date()).format("MM_DD_YYYY") + ".csv";
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
